module.exports = __webpack_public_path__ + "img/icon-thumbs-down.a7eae58c.svg";